if (typeof UADeferredVideo === 'undefined') {

  class UADeferredVideo extends HTMLElement {
      constructor() {
          super();
          this.handleResize = this.addVideo.bind(this);
          this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
              threshold: 0.1 // Load video when 10% of it is in the viewport
          });
      }

      connectedCallback() {
          this.template = this.querySelector('template');
          this.templateVideo = this.template.content.querySelector('video');

          this.minWidth = parseInt(this.dataset.minWidth, 10);
          this.maxWidth = parseInt(this.dataset.maxWidth, 10);

          this.playButton = this.querySelector('[data-media-control="play"]');
          this.pauseButton = this.querySelector('[data-media-control="pause"]');

          if (this.playButton) {
              this.playButton.addEventListener('click', this.playVideo.bind(this));
          }

          if (this.pauseButton) {
              this.pauseButton.addEventListener('click', this.pauseVideo.bind(this));
          }

          // Observe the resize event
          window.addEventListener('resize', this.handleResize);
          this.observer.observe(this);
      }

      handleIntersect(entries) {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  this.addVideo(); // Load the video when it is in the viewport
                  this.playVideo();
                  this.observer.unobserve(this); // Stop observing once the video is loaded
              } else {
                  this.pauseVideo();
                  this.updateMediaPlayingStatus('paused');
              }
          });
      }

      addVideo() {
          // Check if video element has already been added
          if (this.querySelector('video')) {
              return;
          }

          const viewportWidth = document.body.getBoundingClientRect().width;

          if ((this.maxWidth && viewportWidth >= this.minWidth && viewportWidth <= this.maxWidth) || (!this.maxWidth && viewportWidth >= this.minWidth)) {
              // Create and append video only if the width is in range
              this.video = this.templateVideo.cloneNode(true);

              // check if there is no autoplay attribute, temporarily add it and prevent the video from playing
              const hasAutoplayAttribute = this.video.hasAttribute('autoplay');
              if (!hasAutoplayAttribute) {
                  this.video.setAttribute('autoplay', '');
                  this.video.muted = true;
              }

              this.appendChild(this.video);

              if (!hasAutoplayAttribute) {
                  // makes sure the cover photo is displayed in product modal
                  this.video = this.querySelector('video');

                  // pause the video
                  setTimeout(() => {
                      this.video.pause();
                  }, 100);
              }

              // Initialize status
              this.updateMediaPlayingStatus('paused');

              // Add event listeners to update status
              this.video.addEventListener('play', () => {
                  this.updateMediaPlayingStatus('playing');
              });

              this.video.addEventListener('pause', () => {
                  this.updateMediaPlayingStatus('paused');
              });

              // (Optional) Add an event listener for ended to reset status
              this.video.addEventListener('ended', () => {
                  this.updateMediaPlayingStatus('paused');
              });
          }
      }

      playVideo() {
          if (this.video) {
              this.video.play().then(() => {

              }).catch(error => {
                  console.error('Error attempting to play the video:', error);
              });
          }
      }

      pauseVideo() {
          if (this.video) {
              this.video.pause();
          }
      }

      updateMediaPlayingStatus(status) {
          this.setAttribute('data-media-playing-status', status);
      }

      disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          this.observer.unobserve(this);
      }
  }

  customElements.define('ua-deferred-video', UADeferredVideo);
}
